import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import './SecuritizeIdButton.scss';
import logo from './logo_white.svg';

const SecuritizeIdButton = (props) => {
  const { onClick, children, id } = props;
  return (
    <Button
      id={id}
      className="securitize-btn max-width-330 position-relative"
      color="primary"
      type="button"
      size="lg"
      block
      onClick={onClick}
    >
      <img src={logo} alt="" className="position-absolute" />
      {children}
    </Button>
  );
};

SecuritizeIdButton.defaultProps = {
  onClick: () => undefined,
  children: null,
  id: null,
};

SecuritizeIdButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  id: PropTypes.string,
};

export default SecuritizeIdButton;
